export const reasonCellStyles = {
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
};

export const reasonLineStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '6px',
};

export const historyLinkStyles = {
  padding: 0,
  minWidth: 0,
  height: 'auto',
};
